module.exports = __webpack_public_path__ + "img/icdeposit.4e82553a.png";